var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 20C12.8426 20 15.1852 19.0231 17.1111 17.0694C19.037 15.1157 20 12.75 20 9.97222H18.3333C18.3333 12.287 17.537 14.2593 15.9444 15.8889C14.3519 17.5185 12.3981 18.3333 10.0833 18.3333C7.73148 18.3333 5.74074 17.5093 4.11111 15.8611C2.48148 14.213 1.66667 12.213 1.66667 9.86111C1.66667 7.56482 2.49074 5.625 4.13889 4.04167C5.78704 2.45833 7.76852 1.66667 10.0833 1.66667C11.3426 1.66667 12.5231 1.9537 13.625 2.52778C14.7269 3.10185 15.6852 3.86111 16.5 4.80556H13.5833V6.47222H19.3889V0.694444H17.7222V3.63889C16.7593 2.50926 15.6157 1.62037 14.2917 0.972222C12.9676 0.324074 11.5648 0 10.0833 0C8.69444 0 7.38889 0.259259 6.16667 0.777778C4.94444 1.2963 3.875 2.00463 2.95833 2.90278C2.04167 3.80093 1.31944 4.85185 0.791666 6.05556C0.263887 7.25926 0 8.55556 0 9.94444C0 11.3333 0.263887 12.6389 0.791666 13.8611C1.31944 15.0833 2.04167 16.1481 2.95833 17.0556C3.875 17.963 4.94444 18.6806 6.16667 19.2083C7.38889 19.7361 8.69444 20 10.0833 20Z",
    fill: "white",
    fillOpacity: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.c3e9695656671e5819489f388fdc941e.svg";
export { ForwardRef as ReactComponent };